// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__SXTn0","banner":"Header_banner__oWa9Y","flyInText":"Header_flyInText__SACAL","hidden":"Header_hidden__LWXR0"};